import { streamToString } from './utils.js';

const isV2Flow = async (s3, envId, tenantId, flowId) => {
  try {
    const fileStream = s3
      .getObject({
        Bucket: envId,
        Key: `${tenantId}/flows/${flowId}/flow.json`,
      })
      .createReadStream();

    const fileString = await streamToString(fileStream);

    const fileJson = JSON.parse(fileString);

    return fileJson.version === 2;
  } catch (error) {
    return false;
  }
};

const getEntityLabel = async (s3, envId, tenantId, flowId, isV2 = undefined) => {
  const _isV2Flow = isV2 ?? (await isV2Flow(s3, envId, tenantId, flowId));
  return _isV2Flow ? 'connectors' : 'taps';
};

export { isV2Flow, getEntityLabel };
